import { takeLatest, put, call, fork } from "redux-saga/effects";
import PaymentProgramService from "services/payment-program-service";

import {
    fetchedPaymentProgramDetails,
    failedFetchPaymentProgramDetails,
    updatedUserDocumentDetails,
    failedUpdateUserDocumentDetails,
    fetchUpdatedChecklistJson,
    failedFetchUpdateChecklistJson,
    fetchedUpdateEntityDocuments,
    failedUpdateEntityDocuments,
    fetchedPaymentProgramActionDetails,
    failedFetchPaymentProgramActionDetails
} from "actions";

import { PAYMENT_PROGRAM_ACTIONS } from "constants/actions";
import { message } from "antd";

function* fetchPaymentProgramDetails({ payload }) {
    try {
        const {data, error} = yield call(
            PaymentProgramService.fetchPaymentProgramDetails,
            payload.requestType,
            payload.page,
            payload.page_size,
            payload.filters
        );
        if(!error) {
            yield put(fetchedPaymentProgramDetails(payload.requestType, payload.page, payload.page_size, data));
        } else {
            yield put(failedFetchPaymentProgramDetails(payload.requestType, payload.page, payload.page_size, error));
        }
    } catch (error) {
        yield put(failedFetchPaymentProgramDetails(payload.requestType, payload.page, payload.page_size, error));
    }
}


function* fetchPaymentProgramActionDetails({ payload : {case_id  ,onboarding_id} }) {
    try {
        const {data, error} = yield call(
            PaymentProgramService.fetchPaymentProgramActionDetails,
            case_id,
            onboarding_id
        );
        if(!error) {
            yield put(fetchedPaymentProgramActionDetails(data , case_id));
        } else {
            yield put(failedFetchPaymentProgramActionDetails(error));
        }
    } catch (error) {
        yield put(failedFetchPaymentProgramActionDetails(error));
    }
}


function* updateUserDocumentDetails({ payload }) {
    try {
        const {data, error} = yield call(
            PaymentProgramService.validateDocument,
            payload.company_id,
            payload.document_id,
            payload.data
        );
        if(!error) {
            yield put(updatedUserDocumentDetails(data));
        } else {
            yield put(failedUpdateUserDocumentDetails(error));
        }
    } catch (error) {
        yield put(failedUpdateUserDocumentDetails(error));
    }
}

function* fetchUpdateChecklistJson({ payload }) {
    try {
        const {data, error} = yield call(
            PaymentProgramService.updateCaseChecklist,
            payload.case_id,
        );
        if(!error) {
            yield put(fetchUpdatedChecklistJson(data));
        } else {
            yield put(failedFetchUpdateChecklistJson(error));
        }
    } catch (error) {
        yield put(failedFetchUpdateChecklistJson(error));
    }
}

function* fetchUpdateEntityDocuments({ payload }) {
    try {
        if(payload.callAPi){
            yield put(fetchedUpdateEntityDocuments({}));
        }else{
            const {data, error} = yield call(
                PaymentProgramService.updateEntityDocuments,
                payload.company_id,
                payload.action_detail_id,
                payload.data
            );
            if(!error) {
                yield put(fetchedUpdateEntityDocuments(data));
            } else {
                yield put(failedUpdateEntityDocuments(error));
            }
        }
    } catch (error) {
        message.error("Some Error Occured!");
        yield put(failedUpdateEntityDocuments(error));
    }
}

export default fork(function*() {
    yield takeLatest(PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_DETAILS, fetchPaymentProgramDetails);
    yield takeLatest(PAYMENT_PROGRAM_ACTIONS.UPDATE_USER_DOCUMENT_DETAILS , updateUserDocumentDetails);
    yield takeLatest(PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATE_CHECKLIST_JSON , fetchUpdateChecklistJson);
    yield takeLatest(PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATE_ENTITY_DOCUMENTS , fetchUpdateEntityDocuments);
    yield takeLatest(PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_ACTION_DETAILS , fetchPaymentProgramActionDetails);

});